import { BehaviorSubject } from "rxjs";

export class FilterableService extends BehaviorSubject<any[]> {
    filteredData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    length: number;
    minimumFilterLength: number = 0;
    private checkCount: number = 0;

    constructor(data: any[] = []) {
        super(data);
        this.subscribe(x => this.resetFilter());
    }

    /**
     * 
     */
    resetFilter() {
        try {
            this.checkCount = 0;
            this.length = this.value.length;
            this.updateFilteredData();
        } catch (e) { }
    }


    updateFilteredData(data: any[] = this.value) {
        if (this.checkCount >= this.minimumFilterLength) {
            this.filteredData.next(data);
        }
    }


    /**
     * 
     */
    handleFilter(check: string, field: string = undefined, selected: any[] = []): void {
        let result: any[] = this.value;
        try {
            if (check && check !== '') {
                this.checkCount = this.checkCount + 1;
                result = this.value.filter(x => {
                    const source: string = field ? x[field].toString() : x.toString();
                    return source.toLowerCase().indexOf(check.toLowerCase()) !== -1;
                });
            }
        } catch (e) { }

        if (check && check !== '' && selected instanceof Array) {
            result = result.filter(x => !selected.some(s => {
                const source = x.Id || x;
                const check = s.Id || s;
                return source === check;
            }));
        }
        this.updateFilteredData(result);
    }

}
